export class ListLogSourcesResponse {
    'logSources';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "logSources",
            "baseName": "logSources",
            "type": "Array<LogSource>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListLogSourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
